import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=3b4f4f3c&scoped=true&"
import script from "./pageView.vue?vue&type=script&lang=js&"
export * from "./pageView.vue?vue&type=script&lang=js&"
import style0 from "./pageView.vue?vue&type=style&index=0&id=3b4f4f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f4f3c",
  null
  
)

export default component.exports